/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Convert_To_AudioInputs */

const en_dialog_convert_to_audio = /** @type {(inputs: Dialog_Convert_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert to audio`)
};

const es_dialog_convert_to_audio = /** @type {(inputs: Dialog_Convert_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir a audio`)
};

/**
* | output |
* | --- |
* | "Convert to audio" |
*
* @param {Dialog_Convert_To_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_convert_to_audio = /** @type {((inputs?: Dialog_Convert_To_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Convert_To_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_convert_to_audio(inputs)
	return en_dialog_convert_to_audio(inputs)
});